<template>
  	<AddNewWithdrawal />
</template>

<script>

// @ is an alias to /src
import AddNewWithdrawal from "@/components/AddNewWithdrawal.vue";

export default {
  name: "AddNewWithdrawals",
  components: {
    AddNewWithdrawal,
  },
};
</script>
